import { Temporal } from '../temporal';
import { EMPTY_VALUE } from './constants';

const DEFAULT_LOCALE = 'cs-CZ';

/**
 * Format a relative time string: "před 2 dny", "za 3 hodiny"
 * Uses Intl.RelativeTimeFormat for locale-aware output.
 */
export function formatRelativeInstant(
  instant: Temporal.Instant | null | undefined,
  locale: string = DEFAULT_LOCALE
): string {
  if (instant == null) return EMPTY_VALUE;
  const now = Temporal.Now.instant();
  const totalSeconds = now.until(instant).total({ unit: 'second' });

  const rtf = new Intl.RelativeTimeFormat(locale, { numeric: 'auto' });

  const absSeconds = Math.abs(totalSeconds);

  if (absSeconds < 60) {
    return rtf.format(Math.round(totalSeconds), 'second');
  }
  if (absSeconds < 3600) {
    return rtf.format(Math.round(totalSeconds / 60), 'minute');
  }
  if (absSeconds < 86400) {
    return rtf.format(Math.round(totalSeconds / 3600), 'hour');
  }
  if (absSeconds < 2592000) {
    return rtf.format(Math.round(totalSeconds / 86400), 'day');
  }
  if (absSeconds < 31536000) {
    return rtf.format(Math.round(totalSeconds / 2592000), 'month');
  }
  return rtf.format(Math.round(totalSeconds / 31536000), 'year');
}

/**
 * Format a relative date from a PlainDate: "před 2 dny", "za 5 dní"
 */
export function formatRelativeDate(
  date: Temporal.PlainDate | null | undefined,
  locale: string = DEFAULT_LOCALE
): string {
  if (date == null) return EMPTY_VALUE;
  const today = Temporal.Now.plainDateISO();
  const days = today.until(date, { largestUnit: 'day' }).days;

  const rtf = new Intl.RelativeTimeFormat(locale, { numeric: 'auto' });

  const absDays = Math.abs(days);

  if (absDays < 30) {
    return rtf.format(days, 'day');
  }
  if (absDays < 365) {
    return rtf.format(Math.round(days / 30), 'month');
  }
  return rtf.format(Math.round(days / 365), 'year');
}
